<div id="storageContainer" class=container1>

    <div id="storageTitle" class="main-content paddingSection">
        <div id="ftags" class="fact_tags mt-3 clr-white">{{storageTitle}}</div>
    </div>

</div>